import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#1t8gxc7l0__clip0_small)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsx("g", {
          clipPath: "url(#1rzx8dr48__clip1_small)",
          children: _jsxs("g", {
            transform: "translate(-6.5 0)",
            children: [_jsx("rect", {
              x: "0",
              y: "0",
              width: "33",
              height: "6.667",
              fill: "#FDB913"
            }), _jsx("rect", {
              x: "0",
              y: "6.667",
              width: "33",
              height: "6.667",
              fill: "#006A44"
            }), _jsx("rect", {
              x: "0",
              y: "13.333",
              width: "33",
              height: "6.667",
              fill: "#C1272D"
            })]
          })
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "1t8gxc7l0__clip0_small",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "1rzx8dr48__clip1_small",
          children: _jsx("rect", {
            width: "33",
            height: "20",
            fill: "white",
            transform: "translate(-6.5)"
          })
        })]
      })]
    }))
  });
};
export default Component;
